import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import SaudeLogged from '../../../components/auth/saude'

function SaudeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Transparência - Secretaria Municipal de Saúde" />
                <HeaderLogged />
                <Container>
                   <SaudeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default SaudeLoggedScreen;